import React from "react";
import { Medication } from "../../../../messages";
import { STRINGS } from "../../../../strings";
import { translate } from "../../../../translate";
import { AppCardContent } from "../../../Generic/AppCard";
import { IsDefined } from "../../../Generic/IsDefined";
import SearchModalCard from "../../../SearchModal/SearchModalCard/SearchModalCard";
import SearchModalCardNotFound from "../../../SearchModal/SearchModalCard/SearchModalCardNotFound";
import SearchMedicationResults from "../SearchMedicationResults/SearchMedicationResults";

interface Props {
  value?: string;
  medications: Medication[] | null;
  hasError: boolean;
  isOpen: boolean;
  onChange: (newValue: string) => void;
  onRequestClose: () => void;
  onMedicationChosen: (medication: Medication) => void;
}

const SearchMedicationCard = ({
  value,
  medications,
  hasError,
  isOpen,
  onChange,
  onRequestClose,
  onMedicationChosen,
}: Props) => {
  return (
    <SearchModalCard
      placeholder={translate(STRINGS.SEARCH_FOR_MEDICATIONS)}
      value={value}
      hasError={hasError}
      isOpen={isOpen}
      onChange={onChange}
      onRequestClose={onRequestClose}
    >
      <IsDefined value={value}>
        {(definedValue) => (
          <IsDefined value={medications}>
            {(definedMedications) => (
              <AppCardContent style={{ padding: 0, overflow: "auto" }}>
                {definedMedications.length === 0 ? (
                  <SearchModalCardNotFound
                    comment={translate(STRINGS.WE_COULDNT_FIND_THE_MEDICATION_YOURE_LOOKING_FOR)}
                  />
                ) : (
                  <SearchMedicationResults
                    medications={definedMedications}
                    marked={definedValue}
                    medicationChosen={onMedicationChosen}
                  />
                )}
              </AppCardContent>
            )}
          </IsDefined>
        )}
      </IsDefined>
    </SearchModalCard>
  );
};

export default React.memo(SearchMedicationCard);
